var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v("Page Not Found")]),_c('v-card-text',[_vm._v(" The page you are looking for does not exist, Try going back to "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }